import { Spinner, Stack } from 'common/design-system/components-v2';

const FullSizeSpinner = () =>
    <Stack alignItems='center' justifyContent='center' fullWidth fullHeight>
        <Spinner />
    </Stack>;

export default FullSizeSpinner;